import { useNavigate } from 'react-router-dom';

import { Grid, styled, Typography } from '@mui/material';

import { CreateButton } from '../../../components/buttons';
import { useGetAllFeaturedBanners } from '../../../lib/featured-banner/hooks';
import { getBannerImage } from '../../../lib/util/helpers';
import { FeaturedBannerType } from '../../../types/FeaturedBanner';

import FeaturedBannerCard from './FeaturedBannerCard';
import FeaturedBannerEmptyState from './FeaturedBannerEmptyState';

const MAX_FEATURED_BANNERS = 10;

function FeaturedBannerList() {
  const navigate = useNavigate();

  const { data: featuredBanners } = useGetAllFeaturedBanners();

  return (
    <Container>
      <FullWidthBar>
        <Typography
          variant="h5"
          component="div"
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: 1,
          }}
        >
          Featured Banner
          <Typography variant="h6" component="span" color="primary">
            {featuredBanners?.length}/{MAX_FEATURED_BANNERS}
          </Typography>
        </Typography>

        <CreateButton variant="contained" onClick={() => navigate('/cms/featured-banner/new')}>
          Add New
        </CreateButton>
      </FullWidthBar>

      {featuredBanners?.length ? (
        <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
          {featuredBanners?.map((banner) => {
            let image = getBannerImage(banner);
            let title = '';
            if (banner.type === FeaturedBannerType.CATEGORY) {
              image = image ?? banner.category?.media?.mediumUrl ?? null;
              title = banner.category?.title || '';
            }
            if (banner.type === FeaturedBannerType.SUB_CATEGORY) {
              image = image ?? banner.subCategory?.media?.mediumUrl ?? null;
              title = banner.subCategory?.title || '';
            }
            if (banner.type === FeaturedBannerType.POST) {
              title = banner.post?.title || '';
            }
            if (banner.type === FeaturedBannerType.ADVERTISEMENT) {
              image = image ?? banner.advertisement?.media?.mediumUrl ?? null;
              title = banner.advertisement?.title || '';
            }
            if (banner.type === FeaturedBannerType.ANNOUNCEMENT) {
              image = image ?? banner.announcement?.media?.mediumUrl ?? null;
              title = banner.announcement?.title || '';
            }

            return (
              <Grid key={banner.id} item xs={12} sm={12} md={4} lg={4} xl={4}>
                <FeaturedBannerCard id={banner.id} image={image} title={title} type={banner.type} />
              </Grid>
            );
          })}
        </Grid>
      ) : (
        <FeaturedBannerEmptyState />
      )}
    </Container>
  );
}

export default FeaturedBannerList;

const Container = styled('div')({
  padding: '20px',
  backgroundColor: '#eee',
  flex: 1,
  display: 'flex',
  alignItems: 'stretch',
  flexDirection: 'column',
  gap: '2rem',
});

const FullWidthBar = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  margin: '8px 0',
  justifyContent: 'space-between',
  alignItems: 'center',
});
